import { render, staticRenderFns } from "./UpdateApplicationStatus.vue?vue&type=template&id=1ef768a5"
import script from "./UpdateApplicationStatus.vue?vue&type=script&lang=js"
export * from "./UpdateApplicationStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateApplicationStatus.vue?vue&type=style&index=0&id=1ef768a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports